import { CheckObjectValue } from 'types/common';

export const updateUserStatusQuery = (userStatus: CheckObjectValue): CheckObjectValue => {
  const inactiveChecked = userStatus['0'];
  const activeChecked = userStatus['1'];

  if (inactiveChecked && activeChecked) {
    return {
      '999': true,
    };
  }

  if (activeChecked) {
    return {
      '1': true,
    };
  }

  if (inactiveChecked) {
    return {
      '0': true,
      '-1': true,
      '-2': true,
      '-9': true,
      '-99': true,
    };
  }

  return {};
};
